import React from 'react';
import classNames from 'classnames';
import { getTailwindClassesByEnum } from '@/utils/cssHelpers';
import { ColumnOrderEnum, GridColumnSizes } from '@/enums/styling';
import { compose } from '@/utils/story-composer';

function Column({ elementProps, content, columnWidth, order }) {
	const tailWindClasses = getTailwindClassesByEnum({ ...GridColumnSizes, ...ColumnOrderEnum }, [...columnWidth, order]);

	return (
		<div className={classNames('flex flex-col col-span-6', tailWindClasses)} {...elementProps}>
			{content}
		</div>
	);
}

export default Column;

compose('column', Column, { children: ['content'] });
